/**
 * Dependencies.
 */
import { BaseModel } from '@prz-dp/services';

/**
 * Export `VehicleerModel`.
 */
export default class VehicleModel extends BaseModel {
  /**
   * Properties.
   */
  code: string;

  number: number;

  photo: {
    encodedFileContent: string;
    mediaType: string;
  };

  photoLink?: string;

  vehicleType: {
    code: string;
    name: string;
  };

  /**
   * Constructor.
   */
  constructor(data: Partial<VehicleModel>) {
    super(data);
  }
}
